import { TriggerState } from '../state/TriggerState';
import { isTriggerValid } from './isTriggerValid';

export const hasActiveCampaignTriggers = (campaignTriggers: TriggerState): boolean => {
  if (!campaignTriggers?.selectedTriggers?.length) {
    return false;
  }

  return campaignTriggers.selectedTriggers.some(triggerType => isTriggerValid(triggerType, campaignTriggers));
};
